export const CREATE_API =
  "https://ppxtby0g3h.execute-api.ap-southeast-1.amazonaws.com/dev/v3/user-kyc/create";
export const TO_BOT =
  "https://sykes-bot-prod.azurewebsites.net/api/applicationStatus";
export const FETCH_KYC =
  "https://ppxtby0g3h.execute-api.ap-southeast-1.amazonaws.com/dev/v3/user-kyc";
export const CORS = "https://chatbot-corsproxy.herokuapp.com/";

